import React from 'react';
// Loading Modal Component
const LoadingModal = ({ showLoadingModal, loadingMessage }) => {
    if (!showLoadingModal) return null;

    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
            <div className="bg-white dark:bg-[#23272c] rounded-xl shadow-lg w-[90%] max-w-md p-6 relative">
                {/* Spinner and Message Container */}
                <div className="flex flex-col items-center justify-center space-y-4">
                    {/* Spinner */}
                    <div className="w-12 h-12 border-4 border-gray-300 border-t-[#327691] rounded-full animate-spin"></div>

                    {/* Loading Message */}
                    <div className="text-center">
                        <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-2">
                            {loadingMessage}
                        </h3>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoadingModal;